import React, { ReactNode, useState, useCallback, useRef } from 'react';

import { DisclaimerContext } from '../../context/disclaimer.context.ts';

interface DisclaimerProviderProps {
  children: ReactNode;
}

export const DisclaimerProvider = ({
  children,
}: DisclaimerProviderProps): JSX.Element | null => {
  const [checkoutUrl, setCheckoutUrl] = useState('');
  const [sliceDisclaimers, setSliceDisclaimers] = useState<
    Record<string, string>
  >({});
  const sliceDisclaimersRef = useRef<Record<string, string>>({});

  const setSliceDisclaimer = useCallback(
    (sliceId: string, disclaimerText: string) => {
      setSliceDisclaimers((prev) => {
        const newDisclaimers = {
          ...prev,
          [sliceId]: disclaimerText,
        };
        sliceDisclaimersRef.current = newDisclaimers;
        return newDisclaimers;
      });
    },
    [],
  );

  const getSliceDisclaimer = useCallback((sliceId: string): string => {
    return sliceDisclaimersRef.current[sliceId] || '';
  }, []);

  return (
    <DisclaimerContext.Provider
      value={{
        checkoutUrl,
        setCheckoutUrl,
        setSliceDisclaimer,
        getSliceDisclaimer,
      }}
    >
      {children}
    </DisclaimerContext.Provider>
  );
};
